/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'send': {
    width: 200.195,
    height: 200,
    viewBox: '0 0 1025 1024',
    data: '<defs/><path pid="0" d="M971.388 23.76L28.098 518.406c-38.803 20.337-37.211 50.146 3.502 66.264l120.429 47.598c40.633 16.079 102.24 7.363 136.785-19.66l523.024-412.426c34.386-27.102 38.087-23.082 8.198 8.915l-413.5 442.672c-29.968 31.878-21.053 70.96 19.7 86.84l14.089 5.531c40.753 15.76 107.374 42.266 147.929 58.821l133.561 54.364c40.594 16.517 73.786 30.207 73.786 30.446 0 .239.238.995.437 1.035.2.08 9.79-34.386 21.252-76.651l203.686-748.48c11.462-42.305-10.785-60.214-49.588-39.917zM410.874 788.794l-92.41-37.808c-40.515-16.595-59.936 2.866-43.141 43.34.04 0 85.804 206.71 83.416 213.994-2.467 7.243 82.302-122.658 82.302-122.658C465 848.97 451.39 805.39 410.874 788.794z"/>'
  }
})
